import { useExodus, useSelectors } from '@exodus/headless-react';
import React, { useCallback, useState } from 'react';
import { useQuoteContext } from '../../context/quote.js';
import useFromAsset from '../../hooks/use-from-asset.js';
import useFromWalletAccount from '../../hooks/use-from-wallet-account.js';
import usePrefilledAmountId from '../../hooks/use-prefilled-amount-id.js';
import useResetForm from '../../hooks/use-reset-form.js';
import useSlippage from '../../hooks/use-slippage.js';
import useToAmount from '../../hooks/use-to-amount.js';
import useToAsset from '../../hooks/use-to-asset.js';
import useToWalletAccount from '../../hooks/use-to-wallet-account.js';
import { useValidationContext } from '../../context/validation.js';
import { useLimitsContext } from '../../context/limits.js';
import useIsExchangeLoading from '../../hooks/use-exchange-loading.js';
import { useSelector } from 'react-redux';
import useCanExchange from '../../hooks/use-can-exchange.js';
import useFromAmount from '../../hooks/use-from-amount.js';
import useTrackAssetSwap from '../../hooks/analytics/use-track-asset-swap.js';
import useSwapMode from '../../hooks/use-swap-mode.js';
const SubmitButton = ({ Component, className, style, onPress }) => {
    const exodus = useExodus();
    const selectors = useSelectors();
    const [submitting, setSubmitting] = useState(false);
    const [fromAsset] = useFromAsset();
    const [fromAmount] = useFromAmount();
    const [toAsset] = useToAsset();
    const [toAmount] = useToAmount();
    const [fromWalletAccount] = useFromWalletAccount();
    const [prefilledAmountId] = usePrefilledAmountId();
    const quote = useQuoteContext();
    const [toWalletAccount] = useToWalletAccount();
    const [slippage] = useSlippage();
    const resetForm = useResetForm();
    const { preventFromExchanging } = useValidationContext();
    const limits = useLimitsContext();
    const canExchange = useCanExchange();
    const exchangeLoading = useIsExchangeLoading();
    const fiatRatesLoading = useSelector(selectors.rates.loading);
    const [swapMode] = useSwapMode();
    const loading = exchangeLoading || limits.loading || fiatRatesLoading || quote.loading;
    const trackAnalytic = useTrackAssetSwap();
    const handlePress = useCallback(async () => {
        if (submitting || !quote.value) {
            return;
        }
        setSubmitting(true);
        exodus.exchange
            .exchange({
            fromAmount,
            fromAssetName: fromAsset.name,
            fromWalletAccount: fromWalletAccount.toString(),
            isSendAll: prefilledAmountId === 'max',
            providerName: quote.value.providerName,
            slippage,
            toAmount,
            toAssetName: toAsset.name,
            toWalletAccount: toWalletAccount.toString(),
            exchangeButton: prefilledAmountId,
            exchangeDirection: 'from',
            rateId: quote.value.rateId,
            swapMode,
            quoteId: quote.value.id,
        })
            .then(() => {
            resetForm();
            void trackAnalytic({ success: true });
        })
            .catch((err) => {
            console.error(err);
            void trackAnalytic({ success: false });
        })
            .finally(() => {
            setSubmitting(false);
        });
        void onPress?.();
    }, [
        submitting,
        exodus.exchange,
        fromAmount,
        fromAsset.name,
        fromWalletAccount,
        onPress,
        trackAnalytic,
        prefilledAmountId,
        quote.value,
        resetForm,
        slippage,
        toAmount,
        toAsset.name,
        toWalletAccount,
        swapMode,
    ]);
    if (Component) {
        return (React.createElement(Component, { disabled: !canExchange || submitting, visible: !preventFromExchanging, loading: loading, className: className, style: style, onPress: handlePress }));
    }
    return null;
};
export default SubmitButton;
